const TURNSTILE_SCRIPT_PREFIX = "https://challenges.cloudflare.com/turnstile/v0/api.js";
const TURNSTILE_SCRIPT_SELECTOR = `script[src^="${TURNSTILE_SCRIPT_PREFIX}"]`;
const TURNSTILE_SCRIPT_TIMEOUT_MS = 15000;
const TURNSTILE_SCRIPT_ATTRIBUTE = "data-nexus-turnstile-script";

let scriptPromise = null;

function turnstileGlobal() {
  return typeof window !== "undefined" ? window.turnstile : undefined;
}

function existingScript() {
  if (typeof document === "undefined") return null;
  return document.querySelector(`script[${TURNSTILE_SCRIPT_ATTRIBUTE}], ${TURNSTILE_SCRIPT_SELECTOR}`);
}

/** Load the official Turnstile API once and share the result across mounts. */
export function loadTurnstileScript() {
  if (turnstileGlobal()) return Promise.resolve(turnstileGlobal());
  if (scriptPromise) return scriptPromise;

  scriptPromise = new Promise((resolve, reject) => {
    let script = existingScript();
    const createdByNexus = !script;
    let settled = false;
    let readinessTimer = null;
    let timeoutTimer = null;

    const cleanup = () => {
      if (readinessTimer) window.clearInterval(readinessTimer);
      if (timeoutTimer) window.clearTimeout(timeoutTimer);
      if (script) {
        script.removeEventListener("load", onLoad);
        script.removeEventListener("error", onError);
      }
    };
    const finish = (error) => {
      if (settled) return;
      settled = true;
      cleanup();
      if (error && createdByNexus && script?.parentNode) script.parentNode.removeChild(script);
      if (error) reject(error);
      else resolve(turnstileGlobal());
    };
    const checkReady = () => {
      if (turnstileGlobal()) {
        finish();
        return true;
      }
      return false;
    };
    const onLoad = () => {
      if (checkReady()) return;
      let attempts = 0;
      readinessTimer = window.setInterval(() => {
        attempts += 1;
        if (checkReady() || attempts >= 20) {
          if (attempts >= 20 && !turnstileGlobal()) finish(new Error("turnstile_script_unavailable"));
        }
      }, 50);
    };
    const onError = () => finish(new Error("turnstile_script_load_failed"));

    if (!script) {
      script = document.createElement("script");
      script.src = `${TURNSTILE_SCRIPT_PREFIX}?render=explicit`;
      script.async = true;
      script.defer = true;
      script.setAttribute(TURNSTILE_SCRIPT_ATTRIBUTE, "true");
      document.head.appendChild(script);
    }
    script.addEventListener("load", onLoad, { once: true });
    script.addEventListener("error", onError, { once: true });
    timeoutTimer = window.setTimeout(() => finish(new Error("turnstile_script_load_timeout")), TURNSTILE_SCRIPT_TIMEOUT_MS);
    checkReady();
  }).catch((error) => {
    scriptPromise = null;
    throw error;
  });

  return scriptPromise;
}

export const TURNSTILE_SCRIPT_URL = TURNSTILE_SCRIPT_PREFIX;
